import { AttributeCategoriesGridView } from '~/components/attributes/categories';
import { PageContainer } from '~/components/page-container';

export function AttributeCategories() {
	return (
		<PageContainer>
			<AttributeCategoriesGridView />
		</PageContainer>
	);
}
